<template>
  <div>
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      style="margin-bottom:40px"
    >
      <el-breadcrumb-item :to="{ path: '/userTab' }"
        >企业信息</el-breadcrumb-item
      >
      <el-breadcrumb-item>合作伙伴认证</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <div class="xingxi">
        <div class="tiao"></div>
        <i>数据采集合作伙伴认证(通航有人机)</i>
      </div>
      <div class="biaodan">
        <el-form
          label-position="top"
          label-width="80px"
          :model="ruleForm"
          ref="ruleForm"
          :rules="userRules"
        >
          <el-form-item label="测绘行业案例：" prop="mappingCase">
            <el-input
              type="textarea"
              autosize
              v-model="ruleForm.mappingCase"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="作业范围：" prop="range">
            <el-select
              v-model="ruleForm.range"
              placeholder="请选择"
              style="width:240px"
            >
              <el-option label="0-10平方公里" value="0-10平方公里"></el-option>
              <el-option
                label="10-100平方公里"
                value="10-100平方公里"
              ></el-option>
              <el-option
                label="100-1000平方公里"
                value="100-1000平方公里"
              ></el-option>
              <el-option
                label="1000平方公里以上"
                value="1000平方公里以上"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否有固定空域：" prop="airspace">
            <el-radio-group v-model="ruleForm.airspace">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
            <el-form-item
              style="display: inline-block;"
              prop="airspaceDetails"
              v-if="this.ruleForm.kongyu == '是'"
            >
              <el-input
                type="textarea"
                autosize
                v-model="ruleForm.airspaceDetails"
                placeholder="请输入固定空域"
                style="width:200px;margin-left: 10px;"
              ></el-input>
            </el-form-item>
          </el-form-item>
          <el-form-item label="可申请哪些区域空域：" prop="applicableAirspace">
            <el-input
              type="textarea"
              autosize
              v-model="ruleForm.applicableAirspace"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="飞行器类型：" prop="flight">
            <el-input
              type="textarea"
              autosize
              v-model="ruleForm.flight"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="传感器：" prop="sensor">
            <el-input
              type="textarea"
              autosize
              v-model="ruleForm.sensor"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否有适航许可：" prop="airworthinessPermit">
            <el-radio-group v-model="ruleForm.airworthinessPermit">
              <el-radio label="是"></el-radio>
              <el-radio label="否"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="电子邮箱：" prop="Email">
            <el-input
              type="textarea"
              autosize
              v-model="ruleForm.Email"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item v-if="this.bohuizhuangtai">
            <div>
              <i style="color: #f56c6c;" class="bitianshangchuan">
                驳回原因：</i
              >
            </div>
            <el-input
              style="width:320px"
              :disabled="true"
              :rows="4"
              type="textarea"
              v-model="testData.data.yourenbohui"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="upimg">
        <div class="shangchuan">
          <div style="padding-bottom:20px;">
            <i class="shenfen"> 测绘资质证书扫描件：</i>
          </div>
          <upload
            :toPicture="UpPicture.mannedMappingUrl"
            @fromChild="mappingUpPicture"
          ></upload>
        </div>
        <div class="shangchuan1">
          <div style="padding-bottom:20px;">
            <i class="shenfen"> 适航证上传：</i>
          </div>
          <upload
            :toPicture="UpPicture.mannedUrl"
            @fromChild="mannedUpPicture"
          ></upload>
        </div>
      </div>

      <div class="anniu">
        <el-button type="primary" @click="submission()">提交确认</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import upload from "../../components/upload";
import { mannedCollectData } from "../../assets/js/DataTemplate";
export default {
  components: {
    upload
  },
  data() {
    return {
      manned: {
        mannedMappingUrl: [],
        mannedUrl: []
      },
      UpPicture: {},

      ruleForm: {
        Email: "",
        flight: "",
        range: "",
        airspace: "",
        airspaceDetails: "",
        mappingCase: "",
        sensor: "",
        applicableAirspace: "",
        airworthinessPermit: "",
        yourenbohui: ""
      },
      //检验规则
      userRules: {
        flight: [
          { required: true, message: "请输入飞行器类型", trigger: "blur" }
        ],
        range: [
          { required: true, message: "请选择作业范围", trigger: "change" }
        ],
        Email: [{ required: true, message: "请输入邮箱地址", trigger: "blur" }],
        airspace: [
          { required: true, message: "请选择是否有固定空域", trigger: "change" }
        ],
        mappingCase: [
          { required: true, message: "请输入测绘行业案例", trigger: "blur" }
        ],
        sensor: [{ required: true, message: "请输入传感器", trigger: "blur" }],
        applicableAirspace: [
          { required: true, message: "请输入可申请区域空域", trigger: "blur" }
        ],
        airspaceDetails: [
          { required: true, message: "请输入固定空域", trigger: "blur" }
        ],
        airworthinessPermit: [
          { required: true, message: "请选择是否有适航许可", trigger: "change" }
        ]
      },
      //添加属性
      udate: {
        function: "t_user",
        id: "",
        jsonData: { data: "" }
      },

      //上传认证
      companydate: {
        type: 4,
        userJsonData: { data: {} }
      },

      application: {
        host: "parallelword@terra-it.cn",

        title: "平行世界",
        content: ""
      },
      bohuizhuangtai: false
    };
  },
  created() {
    this.sessionData();
  },
  methods: {
    mannedUpPicture(data) {
      this.manned.mannedUrl = [];
      data.forEach(e => {
        this.manned.mannedUrl.push(e.UpName);
      });
    },
    mappingUpPicture(data) {
      this.manned.mannedMappingUrl = [];
      data.forEach(e => {
        this.manned.mannedMappingUrl.push(e.UpName);
      });
    },
    async submit() {
      var content = `平行世界有合作伙伴认证待处理`;
      this.application.content = content;
      const { data: dt } = await this.$http.post(
        "general/sendMail",
        this.application
      );
      if (dt.status !== 200) {
        return this.$message.error(dt.msg);
      }
    },
    //获取session中数据
    async sessionData() {
      let config = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      };
      const { data: dt } = await this.$http.post(
        "user/getUserInfo",
        "",
        config
      );
      if (dt.status == 500) {
        this.$confirm("身份认证过期请重新登陆", "退出", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            window.sessionStorage.removeItem("token");
            // window.sessionStorage.removeItem("tempData");
            this.$router.push("/login");
          })
          .catch(() => {});
        // return this.$message.error("身份认证过期请重新登陆");
      }
      this.testData = dt.data;
      this.testData.auth.forEach(e => {
        if (e.type == 4) {
          if (e.status == 2) {
            this.bohuizhuangtai = true;
          }
        }
      });
      this.udate.id = this.testData.id;
      let data = mannedCollectData(dt.data);
      this.testData = data.mannedData;
      if (this.testData.data.hasOwnProperty("yourenji")) {
        this.ruleForm = this.testData.data.yourenji;
      } else if (this.testData.data.hasOwnProperty("manned")) {
        this.ruleForm = this.testData.data.manned;
      }
      this.UpPicture = data.mannedUpPicture;
      console.log(this.testData);
    },
    //提交请求
    submission() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$confirm("确认要提交认证么?", "提交", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(async () => {
              const manned = this.ruleForm;
              manned.mannedMappingUrl = this.manned.mannedMappingUrl.toString();
              manned.mannedUrl = this.manned.mannedUrl.toString();

              if (this.testData.data.hasOwnProperty("yourenji")) {
                this.testData.data.yourenji = JSON.stringify(manned);
                this.companydate.userJsonData.data = JSON.stringify(
                  this.testData.data
                ).replace(/yourenji/g, "manned");
              } else {
                this.testData.data.manned = JSON.stringify(manned);
                this.companydate.userJsonData.data = JSON.stringify(
                  this.testData.data
                );
              }

              this.companydate.userJsonData = JSON.stringify(
                this.companydate.userJsonData
              );

              const { data: dt } = await this.$http.post(
                "user/auth",
                this.companydate
              );

              if (dt.status !== 200) {
                return this.$message.error(dt.msg);
              }
              this.submit();
              this.$message({
                message: "提交成功",
                type: "success"
              });

              this.$router.push("/users");
            })
            .catch(() => {});
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.el-select {
  width: 320px;
}
i {
  font-style: normal;
}

.el-card {
  width: 100%;
  height: 100%;
  position: relative;
  // overflow: auto;
  margin-bottom: 30px;
  .xingxi {
    // width: 180px;
    // position: absolute;
    // left: 50px;
    // top: 60px;
    // margin-left: 50px;
    margin-top: 20px;
    margin-bottom: 20px;
    .tiao {
      width: 4px;
      height: 15px;
      background: rgba(0, 134, 253, 1);
      display: inline-block;
      margin-right: 10px;
    }
    i {
      // width: 65px;
      font-weight: bold;
      font-size: 16px;
    }
  }

  .tupian {
    position: relative;
  }
  .shangchuan1 {
    margin-top: 30px;
  }
}

.anniu {
  margin-top: 30px;
  width: 100%;
  text-align: center;
  .el-button {
    width: 260px;
    height: 50px;
    // position: absolute;
    // left: 50%;
    // top: 830px;
    // transform: translateX(-50%);
  }
}
</style>
